<template>
  <v-row no-gutters>
    <v-col>
      <content-area :items="items" />
    </v-col>
  </v-row>
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
export default {
  components: {
    ContentArea
  },
  methods: {
    getDateStringOrNone (unixDate) {
      if (unixDate === 0) {
        return this.$tc('none', 2)
      } else {
        return `${this.$getDateString({ date: unixDate })}`
      }
    },
    getTranslatedStateString (state) {
      const stateName = this.$store.getters['keys/getSP80057State']({
        st: state
      })
      return this.$t(stateName)
    }
  },
  props: {
    sp: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    items () {
      const info = this.sp
      if (info) {
        return [
          {
            title: this.$tc('state'),
            data: this.getTranslatedStateString(info.state)
          },
          {
            title: this.$tc('mask'),
            data: info.umask
          },
          {
            title: this.$tc('initial_date'),
            data: this.getDateStringOrNone(info.init)
          },
          {
            title: this.$tc('activation_date'),
            data: this.getDateStringOrNone(info.activ)
          },
          {
            title: this.$tc('archive_date'),
            data: this.getDateStringOrNone(info.archive)
          },
          {
            title: this.$tc('compromisse_date'),
            data: this.getDateStringOrNone(info.comprom)
          },
          {
            title: this.$tc('compromisse_occurrence_date'),
            data: this.getDateStringOrNone(info.c_occur)
          },
          {
            title: this.$tc('deactivation_date'),
            data: this.getDateStringOrNone(info.deactiv)
          },
          {
            title: this.$tc('last_change_date'),
            data: this.getDateStringOrNone(info.last_change)
          },
          {
            title: this.$tc('original_creation_date'),
            data: this.getDateStringOrNone(info.orig_creat)
          },
          {
            title: this.$tc('process_start_date'),
            data: this.getDateStringOrNone(info.proc_s)
          },
          {
            title: this.$tc('protect_stop_date'),
            data: this.getDateStringOrNone(info.protect_s)
          }
        ]
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
